// import React, { useState, useEffect } from "react";
// import { Container, Row, Col, Navbar } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import lilLogo from '../assets/images/lilLogo.webp'

// const StudentProfileHeader = ({ data }) => {


//     return (
//         <Container style={{ marginTop: '10px', marginBottom: '20px' }}>
//             <Navbar expand="lg" className='fixed-top bg-body-tertiary shadow'>
//                 <Container>
//                     <div className="d-flex justify-content-between align-items-center w-100">
//                         <div className="d-flex align-items-center">
//                             <img src={lilLogo} alt='lilLogo' style={{ height: '7vh' }} className='me-2'></img>
//                             lilTriangle
//                         </div>
//                         {data.schoolLogo && data.name && (
//                             <div>
//                                 <img src={data.schoolLogo} style={{ height: '7vh' }} className='me-2'></img>
//                                 <strong className="text-center">{data.name}</strong>
//                             </div>
//                         )}
//                     </div>
//                 </Container>
//             </Navbar>

//         </Container>
//     )
// }
// export default StudentProfileHeader;

import React from "react";
import { Container, Navbar } from 'react-bootstrap';
import lilLogo from '../assets/images/lilLogo.webp';

const StudentProfileHeader = ({ data }) => {
    return (
        <Container fluid style={{ marginTop: '10px', marginBottom: '20px', padding: 0 }}>
            <Navbar expand="lg" className='fixed-top bg-body-tertiary shadow py-3'>
                <Container className="d-flex justify-content-between align-items-center">
                    {/* Left Side: App Logo and Name */}
                    <div className="d-flex align-items-center">
                        <img 
                            src={lilLogo} 
                            alt='lilLogo' 
                            style={{ height: '6vh' }} 
                            className='me-2'
                        />
                        <span className="fw-bold fs-5">lilTriangle</span>
                    </div>

                    {/* Right Side: School Logo and Name */}
                    {data.schoolLogo && data.name && (
                        <div className="d-flex align-items-center text-end">
                            <img 
                                src={data.schoolLogo} 
                                alt="School Logo" 
                                style={{ height: '6vh', objectFit: 'contain' }} 
                                className='me-2'
                            />
                            <strong className="fs-6">{data.name}</strong>
                        </div>
                    )}
                </Container>
            </Navbar>
        </Container>
    );
};

export default StudentProfileHeader;
